//Custom components

import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';
import StatCard from '../../../UI/Card/StatCard';

const TotalGrantsApprovedBPWWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Grants Approved @ BPW' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalGrantsApprovedBPWWidget;
